export function reorderTickets(tickets) {
    const result = [];
    const returnTicketMap = new Map();

    for (const ticket of tickets) {
        if (ticket.isReturnTicket) {
            returnTicketMap.set(ticket.outboundTicketId, ticket);
        }
    }

    for (const ticket of tickets) {
        if (!ticket.isReturnTicket) {
            result.push(ticket);

            const returnTicket = returnTicketMap.get(ticket.id);
            if (returnTicket) {
                result.push(returnTicket);
                returnTicketMap.delete(ticket.id);
            }
        }
    }
    
    const paired = new Set(result);
    for (const ticket of tickets) {
        if (ticket.isReturnTicket && !paired.has(ticket)) {
            result.push(ticket);
        }
    }

    return result;
}
